import { render, staticRenderFns } from "./screenFinal3round2.vue?vue&type=template&id=2d8c4ce8&scoped=true"
import script from "./screenFinal3round2.vue?vue&type=script&lang=js"
export * from "./screenFinal3round2.vue?vue&type=script&lang=js"
import style0 from "./screenFinal3round2.vue?vue&type=style&index=0&id=2d8c4ce8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8c4ce8",
  null
  
)

export default component.exports